export class ScoutError extends Error {
  constructor(public message: string, public extra: any) {
    super(message);
  }
}
